import { Routes, Route, Navigate, useLocation } from "react-router";
import BuyPanelsLayout from "@/components/layouts/BuyPanelsLayout";
import BuyPanels from "@/panel/buypanels/panels/BuyPanels";
import OrderConfirmation from "@/panel/buypanels/confirmation/OrderConfirmation";
import Payment from "@/panel/buypanels/payments/Payment";
import Ownership from "@/panel/buypanels/ownership/Ownership";
import PaymentReturn from "@/panel/buypanels/payments/PaymentReturn";
import ManualPayment from "@/panel/buypanels/payments/ManualPayment";
import ManualPaymentSuccess from "@/panel/buypanels/payments/ManualPaymentSuccess";
import { getBuyPanelsBasePath } from "@/panel/buypanels/route";

export default function BuyPanelsPage() {
  const location = useLocation();
  const routePrefix = getBuyPanelsBasePath(location.pathname);

  return (
    <BuyPanelsLayout>
      <Routes>
        <Route index element={<BuyPanels />} />
        <Route path="confirmation" element={<OrderConfirmation />} />
        <Route path="payment" element={<Payment />} />
        <Route path="payment-return" element={<PaymentReturn />} />
        <Route path="ownership" element={<Ownership />} />
        <Route path="manual-payment" element={<ManualPayment />} />
        <Route path="manual-payment/success" element={<ManualPaymentSuccess />} />
        <Route path="*" element={<Navigate to={routePrefix} replace />} />
      </Routes>
    </BuyPanelsLayout>
  );
}
